// Order redirect (2026-05-29) — project-only access.
//
// Orders (Estimates + Quotes) are viewed INSIDE their project's
// sub-nav, never as a standalone page. Any legacy / bookmarked / global-
// search / clone link to `/orders/:id` lands here, which resolves the
// order's project + stage and forwards to the in-project detail route:
//   quote stage      → /projects/:projectId/estimate/:orderId
//   committed+ stage → /projects/:projectId/sales-order/:orderId
import { Navigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

interface RedirectOrder {
  order: { id: string; projectId: string; statusStage: string };
}

export function OrderRedirect() {
  const { id = "" } = useParams<{ id: string }>();
  const { data, isError } = useQuery({
    queryKey: ["orders", id, "redirect"],
    queryFn: () => api<RedirectOrder>(`/orders/${id}`),
    enabled: id.length > 0,
  });

  if (isError) return <Navigate to="/projects" replace />;
  if (!data) {
    return (
      <div className="px-6 py-24 text-center text-sm text-brown-300">
        Opening order…
      </div>
    );
  }

  const { order } = data;
  // Every order is a Quote now (CEO 2026-10-15) — one place for all stages.
  return (
    <Navigate
      to={`/projects/${order.projectId}/quotes/${order.id}`}
      replace
    />
  );
}
